import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.cbf_1 = get_defaultSystemFS();
  }
}
class NullSyncSystemFS {}
class toAsync$1 {
  constructor($ioDispatcher, $sync) {
    this.dbf_1 = $ioDispatcher;
    this.ebf_1 = $sync;
  }
}
//endregion
function get_NullSystemFS() {
  _init_properties_SystemFS_kt__ntwqsk();
  return NullSystemFS;
}
var NullSystemFS;
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function toAsync(_this__u8e3s4, ioDispatcher) {
  _init_properties_SystemFS_kt__ntwqsk();
  var sync = _this__u8e3s4;
  return new toAsync$1(ioDispatcher, sync);
}
var NullSyncSystemFS_instance;
function NullSyncSystemFS_getInstance() {
  return NullSyncSystemFS_instance;
}
var properties_initialized_SystemFS_kt_k4cs8u;
function _init_properties_SystemFS_kt__ntwqsk() {
  if (!properties_initialized_SystemFS_kt_k4cs8u) {
    properties_initialized_SystemFS_kt_k4cs8u = true;
    NullSystemFS = toAsync(NullSyncSystemFS_instance, Dispatchers_getInstance().d1u_1);
  }
}
var defaultSyncSystemFS;
function get_defaultSystemFS() {
  _init_properties_SystemFS_js_kt__9f6y2x();
  var tmp0 = defaultSystemFS$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('defaultSystemFS', 0, tmp, _get_defaultSystemFS_$ref_1xb0n1(), null);
  return tmp0.k3();
}
var defaultSystemFS$delegate;
function defaultSystemFS$delegate$lambda() {
  _init_properties_SystemFS_js_kt__9f6y2x();
  return get_NullSystemFS();
}
function _get_defaultSystemFS_$ref_1xb0n1() {
  return constructCallableReference(() => get_defaultSystemFS(), 0, 0, 82);
}
var properties_initialized_SystemFS_js_kt_5tdsz9;
function _init_properties_SystemFS_js_kt__9f6y2x() {
  if (!properties_initialized_SystemFS_js_kt_5tdsz9) {
    properties_initialized_SystemFS_js_kt_5tdsz9 = true;
    defaultSyncSystemFS = NullSyncSystemFS_instance;
    defaultSystemFS$delegate = lazy(defaultSystemFS$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion, VOID, VOID, [2, 1, 3]);
initMetadataForObject(NullSyncSystemFS, 'NullSyncSystemFS');
initMetadataForClass(toAsync$1, VOID, VOID, VOID, VOID, [1, 2, 3]);
//endregion
//region block: init
NullSyncSystemFS_instance = new NullSyncSystemFS();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2x8uwmfpm0tzj,
};
//endregion
